<div class="container-fluid" *ngIf="_Service.formHideShow==0">
    <div id="form-wrap">
        <h2 class="heading_all">DOMAIN MASTER</h2>
        <br>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
            <div class="col-md-4 ">
                <table>
                    <thead>
                        <tr>
                            <td>
                                <button type="button" class="btn-sm btn-info" (click)="addNew()"><i class="fas fa-plus"
                                        aria-hidden="true"></i></button>
                            </td>
                            <td style="width:60%;"><input type="text" class="form-control-search" name="search"
                                    [(ngModel)]="term"></td>
                            <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <th class="hidden-xs" style="width:205px;">
                        <div class="AtjIsPoint" (click)="sort('DomainName')">
                            <span *ngIf="!_Service.isFiltering">DomainName</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Service.orderByColName!='DomainName' "></i>
                                <div *ngIf="_Service.orderByColName=='DomainName'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Service.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Service.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Service.isFiltering">
                            <input type="text" #txtDomainNameFilter="ngModel" [(ngModel)]="_Service.DomainNameFilter" placeholder="Domain Name">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Server')">
                            <span *ngIf="!_Service.isFiltering">Server</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Service.orderByColName!='Server' "></i>
                                <div *ngIf="_Service.orderByColName=='Server'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Service.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Service.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Service.isFiltering">
                            <input type="text" #txtServerFilter="ngModel" [(ngModel)]="_Service.ServerFilter" placeholder="Server">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Customer')">
                            <span *ngIf="!_Service.isFiltering">Customer</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Service.orderByColName!='Customer' "></i>
                                <div *ngIf="_Service.orderByColName=='Customer'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Service.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Service.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Service.isFiltering">
                            <input type="text" #txtCustomerFilter="ngModel" [(ngModel)]="_Service.CustomerFilter" placeholder="Customer">
                        </div>
                    </th>
                    <th style="width: 135px;"><em></em> Settings
                        <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                            <i *ngIf="!_Service.isFiltering" class="fas fa-filter"></i>
                            <i *ngIf="_Service.isFiltering" class="fas fa-times"></i>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let obj of _Service.allDomain | orderBy : 'Domain' | gridOperations  :_Service.pageIndex: 
                        {DomainName:_Service.DomainNameFilter,Server:_Service.ServerFilter,
                            Customer:_Service.CustomerFilter}:
                        {Column:_Service.orderByColName,Dir:_Service.orderByDir} ; let i = index"
                    class="ng-scope">
                    <td>{{i+1+((NoOfItems*_Service.pageIndex)-NoOfItems)}}</td>
                    <td style="width:205px;">{{obj.DomainName}}</td>
                    <td>{{obj.Server}}</td>
                    <td>{{obj.Customer}}</td>
                    <td style="width: 135px;">
                        <button type="button" class="btn-success" (click)="onEdit(obj);">
                            <i class="fas fa-pen-square" aria-hidden="true"></i></button>
                        <button type="button" class="btn-danger" (click)="onDelete(obj.ID)"><i
                                class="fas fa-trash" aria-hidden="true"></i></button>
                    </td>
                </tr><!-- end ngRepeat: item in items -->
                <tr>
                    <td colspan="4"
                        *ngIf="(_Service.allDomain?.length<=0 )  || _CommonService.filterdItemCount<1">
                        No Records To Display.</td>
                </tr>
            </tbody>
            <tfoot>
                <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                    <app-grid-pagination (pageIndexValue)="_Service.pageIndex=$event">
                    </app-grid-pagination>
                </td>
            </tfoot>
        </table>
        <div class="margintop"></div>
    </div>
</div>
<app-delete-confirm *ngIf="deletePopUp" [title]="'DOMAIN MASTER'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>